import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="page not-found-page">
      <h1>404</h1>
      <p>Page not found</p>
      <Link to="/" className="btn btn-primary">
        Go Home
      </Link>
    </div>
  );
}
